import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { formatDataBeforeView } from '../../../helpers/GeneralHelper';
import * as model from "../../../models/CandidatesModel";
import { useAuth } from '../../../context/AuthContext';

export const CandidateView = ({module, showModal, setShowModal, data}) => {

  const inputFields = {
    candidate_firstname: 'Candidate Name',
    client_name: 'Client',
    requirement_name: 'Requirement',
    candidate_mobile: 'Mobile',
    candidate_email: 'Email',
    candidate_skills: 'Skills',
    candidate_experience_total: 'Years of Experience (Total)',
    candidate_experience_relevant: 'Years of Experience (Relevant)',
    candidate_present_location: 'Present Location',
    candidate_preffered_location: 'Preffered Location',
    candidate_current_ctc: 'Current CTC',
    candidate_offered_ctc: 'Offered CTC',
    candidate_education: 'Education',
    candidate_current_company: 'Current Company',
    candidate_notice_period: 'Notice Period',
    candidate_remarks: 'Remarks',
    candidate_resume_id: 'Resume',
    status_name: 'Status',
    candidate_update_time: 'Updated At',
    candidate_create_time: 'Created At',
  }
  const formatOptions = [
    {
      'type': 'datetime',
      'column': 'candidate_update_time',
    },
    {
      'type': 'datetime',
      'column': 'candidate_create_time',
    },
  ];

  const { state } = useAuth();
  let user_data = state.user_data;

  const [fields, setFields] = useState(inputFields);
  useEffect(() => {
    if (data) {
      setFields(formatDataBeforeView(data, formatOptions));

      const fetchSelectedSkills = async() => {
        if (! data?._candidate_id) {
          return;
        }
  
        try {
          const response = await model.getSelectedSkills(user_data.user_token, data._candidate_id);
  
          if (typeof response != typeof undefined) {
            let skills = [];
            response.data.skills.forEach(function(item) {
              skills.push(item.skill_name);
            });
  
            setFields((prev) => ({ ...prev, 'candidate_skills': skills.join(', ') }));
          }
        } catch (error) {
          console.error(error);
        }
      };
  
      fetchSelectedSkills();
    }
  }, [data]);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
      <Modal.Header closeButton>
          <Modal.Title>View {module.singularTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-bordered table-hover table-sm">
          <tbody>
            {Object.keys(inputFields).map((item) => 
                  <tr key={item}>
                    {item == 'candidate_resume_id' ? 
                      <>
                        <td>{inputFields[item]}</td>
                        <th><a href={process.env.REACT_APP_ASSETS_URL + '/' + fields[item + '_path']} target='_blank' className='text-primary'>{ fields[item + '_file'] }</a></th>
                      </>
                    :
                    <>
                        <td>{inputFields[item]}</td>
                        <th>{fields[item]}</th>
                        </>
                    }
                  </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};
